import React from "react";
import {
  Box,
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
} from "@mui/material";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

interface Props {
  name: string;
  label: FormControlLabelProps["label"];
  testId?: string;
  tooltip?: {
    title?: string;
    text?: string;
  };
}

type FormInputProps<T extends FieldValues> = SwitchProps &
  Props &
  UseControllerProps<T>;

export const RHFSwitchToggle = <T extends FieldValues>(
  props: FormInputProps<T>
): React.ReactNode => {
  const { control, name, defaultValue, label, testId, ...rest } = props;
  const { field } = useController({ control, name, defaultValue });

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      gap={3}
    >
      <FormControlLabel
        control={
          <Switch
            checked={field.value}
            onChange={field.onChange}
            color="primary"
            size="medium"
            data-testid="tax-and-commission-in-eur-input"
            {...rest}
          />
        }
        label={label}
        data-testid={testId}
        sx={{ marginLeft: 0 }}
      />
    </Box>
  );
};
